import { render, staticRenderFns } from "./inicio-web.html?vue&type=template&id=6270c29b&"
import script from "./inicio-web.ts?vue&type=script&lang=ts&"
export * from "./inicio-web.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports